import React from 'react';
import { AppButton } from '@/components/atoms';

/**
 * `.top-btn` — the 32px utility button of the RAH topbar (TB-07).
 *
 * Built on RA2N's `AppButton`, so focus handling, disabled semantics and the
 * button element itself come from the shared atom; the RAH look comes from
 * `.top-btn` in `rah-shell.scss`, which the stylesheet pins over antd's own
 * chrome. `type="text"` is the variant that brings the least to override.
 *
 * The unread marker is the prototype's `.ping` dot, not antd's `Badge`: `Badge`
 * wraps the icon in its own positioned span and paints a dot of its own colour,
 * which left the `.top-btn .ping` rule styling nothing at all.
 */

interface RahIconButtonProps {
  /** Emoji or SVG shown inside the button. */
  icon: React.ReactNode;
  /** Tooltip and accessible name. */
  label: string;
  /** Show the 未読 dot. */
  unread?: boolean;
  expanded?: boolean;
  disabled?: boolean;
  testId?: string;
  onClick?: () => void;
}

export const RahIconButton = React.forwardRef<HTMLButtonElement, RahIconButtonProps>(
  ({ icon, label, unread = false, expanded, disabled, testId, onClick, ...rest }, ref) => (
    <AppButton
      {...rest}
      ref={ref}
      type="text"
      className="top-btn"
      data-testid={testId}
      title={label}
      aria-label={label}
      aria-expanded={expanded}
      disabled={disabled}
      onClick={onClick}
    >
      {icon}
      {unread && <span className="ping" />}
    </AppButton>
  )
);

RahIconButton.displayName = 'RahIconButton';

export default RahIconButton;
